import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";

import { useAppDispatch } from "store/index";
import { closeModal } from "store/modals/slice";
import { apiRoutes } from "configs/apiRoutes";
import instance from "api/apiClient";
import { ModalTypes } from "configs/types";
import { openModal } from "store/modals/slice";
import { Modal } from "components/Modal/Modal";

const GameSessionModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [url, setUrl] = useState();
  const [entity, setEntity] = useState("");

  const handleInit = async () => {
    try {
      const result = await instance.post(`${apiRoutes.gameInit}`, {
        gameSlug: searchParams.get("game"),
        providerSlug: searchParams.get("provider"),
      });
      setUrl(result.data.url);
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    if (
      searchParams.get("game") !== null &&
      searchParams.get("provider") !== null
    ) {
      handleInit();
    }
    if (searchParams.get("entityId") !== null) {
      setEntity(searchParams.get("entityId") ?? "");
    }
  }, [searchParams]);

  const handleCloseClick = () => {
    navigate(`${location.pathname}`);
    dispatch(closeModal());
    navigate(
      `${location.pathname}?activeModal=${ModalTypes.editGame}&entityId=${entity}`,
    );
    dispatch(openModal({ activeModal: ModalTypes.editGame }));
  };

  return (
    <Modal onClose={handleCloseClick}>
      <Modal.Header />
      <Modal.Content>
        <div className="game-frame-wrapper">
          {url && <iframe src={url}></iframe>}
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default GameSessionModal;
